export const odluka_mjesto_rada = {
    templateId: 29.5,
    category: 3,
    templateTitle: 'Odluka o promjeni mjesta rada',
    templateDescription: `<p>Poslodavac može samostalno, posebnom odlukom, promijeniti mjesto rada radnika, ukoliko ugovor o radu sadrži odredbu da se rad obavlja na različitim mjestima odnosno na mjestima gdje poslodavac obavlja poslovanje.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Mjesto rada obvezni je sastojak ugovora o radu te mora biti navedeno u ugovoru o radu odnosno u pisanoj potvrdi o sklopljenom ugovoru o radu. </p>
    <p>Ukoliko ne postoji stalno ili glavno mjesto rada, potrebna je napomena da se rad obavlja na različitim mjestima te se takva odredba često ugovara na način da radnik obavlja rad u točno određenom mjestu rada, ali i na drugim mjestima gdje poslodavac obavlja svoje poslovanje i ima svoje ispostave.</p>
    <p>U takvom i sličnim slučajevima gdje poslodavac ima ovlast mijenjati samostalno mjesto rada radnika, poslodavac može samostalno promijeniti mjesto rada radniku, posebnom odlukom.</p>
    <p>Ako je u ugovoru o radu određena točna adresa na kojoj se obavlja rad te nema naznake da se rad obavlja na različitim mjestima, poslodavac <strong>ne može</strong> samostalno mijenjati mjesto rada te je za promjenu mjesta rada radnika, potrebna suglasnost volja obje ugovorne strane - poslodavca i radnika.</p>

    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu, Ugovor o radu i dr. </p>
  `,
    
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKU O PROMJENI MJESTA RADA',
    noArticleNumbers: true,
    
    articles: [
      {
          mandatory: true,
          statements: [
              {
                  title: '',
                  type: 'input',
                  mandatory: true,
                  editable: true,
                  parts: [
                      {type: 'text', content: 'Radnik'},
                      { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'iz',},
                      { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                      { type: 'text', content: ',' },
                      { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'OIB:' },
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: '(u daljnjem tekstu: Radnik),'},
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: 'trenutno se nalazi u radnom odnosu kod Poslodavca.'},
                  ],
                  value: '',
              },
          ],
      },
      {
        mandatory: true,
        examplecontent: true,
        statements: [
            {
                title: '',
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Radnik je zaposlen na radnom mjestu ______________________. \r\nUgovorom o radu određeno je da Poslodavac može radno mjesto Radnika izmijeniti odlukom, na način da odredi mjesto rada Radnika tamo gdje Poslodavac obavlja svoje poslovanje i ima svoje ispostave.',
                value: '',
            }],
    },
    {
      mandatory: true,
      examplecontent: true,
      statements: [
          {
              title: '',
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Slijedom navedenog, a s obzirom da od __.__.20__. godine Poslodavac obavlja svoje poslovanje na mjestu rada u __________________, Radnika se upućuje na mjesto rada u ________________________, počevši od __.__.20__. godine.',
              value: '',
          }],
  },

        {
          mandatory: true,
          statements: [
              {
                  title: '',
                  type: 'text',
                  mandatory: true,
                  editable: true,
                  content: 'Sva prava i obveze iz radnog odnosa Poslodavca i Radnika, ostaju ista i neizmijenjena.',
                  value: '',
              }],
      },
      
      {
        title: "",
        mandatory: true,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Ova Odluka stupa na snagu danom donošenja."
          }]
      },
      // {
      //   title: "NAPUTAK O ZAŠTITI PRAVA",
      //   mandatory: true,
      //   dummy: true,
      //   statements: [
      //     {
      //       type: "text",
      //       mandatory: true,
      //       editable: false,
      //       content: "Protiv ove Odluke Radnik može Poslodavcu podnijeti zahtjev radi zaštite svojih prava, u roku od 15 dana od dana dostave ove Odluke."
      //     }]
      // },
      {
          mandatory: true,
          static: true,
          type: 2, // date and place
          statements: [
            {
              type: "input",
              mandatory: true,
              parts: [
                {
                  type: "text",
                  content: "U"
                },
                {
                  type: "input",
                  value: "",
                  placeholder: "Upišite mjesto.",
                  required: true,
                },
                {
                  type: "text",
                  content: ", dana"
                },
                {
                  type: "date",
                  value: new Date(),
                  required: true
                },
                {
                  type: "text",
                  content: "godine."
                }
              ]
            },
          ]
        },
      {
          mandatory: true,
          static: true,
          type: 3,  // signatures
          statements: [],
        },
        {
          static: true,
          mandatory: false,
          type: 4, 
          statements: [
            {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
              help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
            }
          ]
        },
        {
          static: true,
          mandatory: true,
          type: 4, 
          statements: [
            {
              type: 'text',
              mandatory: true,
              editable: true,
              help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
              content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
            },
          ]
        },
      ],
    };
    


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/29.5_odluka_mjesto_rada.ts